import { fileExtensionToType, FileTypes } from "../lib/fileExtensionToType.js";
import { AudioVideoIcon } from "./audio-video-icon.js";
import { DocIcon } from "./doc-icon.js";
import { FolderIcon } from "./folder-icon.js";
import { ImageIcon } from "./image-icon.js";
import { OtherIcon } from "./other-icon.js";
import { PdfIcon } from "./pdf-icon.js";
import { PptIcon } from "./ppt-icon.js";
import { XlsIcon } from "./xls-icon.js";
const iconMap = {
  [FileTypes.IMAGE]: ImageIcon,
  [FileTypes.VIDEO]: AudioVideoIcon,
  [FileTypes.AUDIO]: AudioVideoIcon,
  [FileTypes.PDF]: PdfIcon,
  [FileTypes.ARCHIVE]: FolderIcon,
  [FileTypes.WORD]: DocIcon,
  [FileTypes.EXCEL]: XlsIcon,
  [FileTypes.POWERPOINT]: PptIcon,
  [FileTypes.MISC]: OtherIcon
};
const getIcon = (extension) => {
  return iconMap[fileExtensionToType(extension)] ?? OtherIcon;
};
export {
  getIcon
};
//# sourceMappingURL=get-icon.js.map
